import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ValidationResultModel} from '../../../../../_foundation/models/validation.models';

@Component({
  selector: 'jacking-validation-summary',
  templateUrl: 'jacking-validation-summary.component.html'
})
export class JackingValidationSummaryComponent {
  @Input() result: ValidationResultModel | null = null;

  @Output() dismiss = new EventEmitter<void>();
  @Output() errorClick = new EventEmitter<any>();

  get hasErrors(): boolean {
    return !!this.result?.errors?.length;
  }

  get count(): number {
    return this.result?.errors?.length || 0;
  }

  onDismiss() {
    this.dismiss.emit();
  }

  onErrorClick(err: any) {
    this.errorClick.emit(err);
  }
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/components/jacking-validation-summary/jacking-validation-summary.component.ts